export default __webpack_public_path__ + "static/media/logo-package-dubbing-vi.dff20bbc.png";